<script lang="ts">
  import DataTable, { Head, Body, Row, Cell } from '@smui/data-table';
  import { createEventDispatcher, getContext } from 'svelte';
  import type Leaflet from '../Leaflet.svelte';

  import { runs } from '../../shared/stores/run-data-store';
  import { styles } from '../../shared/styles/styles';
  import { getDateString, msToTime } from '../../shared/utils';

  const { getLeaflet } = getContext('leaflet');
  const dispatch = createEventDispatcher();

  // TODO: type
  function onRunClick(run) {
    const leaflet = getLeaflet() as Leaflet;
    // fade all layers except this one
    leaflet.fadeAllLayers();
    run.gpx.setStyle({ opacity: styles.pathOpacity });
    dispatch('runclick');
  }
</script>

<!-- TODO: sortable -->
<!-- <DataTable table$aria-label="Run list" style="width: 100%; height: 100%"> -->
<DataTable table$aria-label="Run list" style="width: 100%; height: 100%">
  <Head style="position: sticky; top: 0">
    <Row style="width: 100%">
      <Cell>Date</Cell>
      <Cell>Miles</Cell>
      <Cell>Time</Cell>
      <Cell>Pace</Cell>
    </Row>
  </Head>
  <Body style="overflow: auto; height: 100%">
    {#each $runs as run}
      <Row on:click={() => onRunClick(run)} style="cursor: pointer; width: 100%">
        <Cell>{getDateString(run.data.start)}</Cell>
        <Cell>{run.data.distance.toFixed(2)} mi</Cell>
        <Cell>{msToTime(run.data.totalTime)}</Cell>
        <Cell>{msToTime(run.data.pace).slice(3)}</Cell>
      </Row>
    {/each}
  </Body>
</DataTable>
